/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, matchPath, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const { pathname } = useLocation();
  // Match complete path segments while keeping nested pages active.
  function activeRoute(routeName) {
    return Boolean(matchPath(pathname, { path: routeName }));
  }
  const { color, logo, image, logoText, routes } = props;

  const [collapses, setCollapses] = React.useState(() => {
    const initialState = {};
    if (routes) {
      routes.forEach((prop, key) => {
        if (prop.collapse && prop.views) {
          const isAnyChildActive =
            prop.views.some(v => activeRoute(v.layout + v.path)) ||
            activeRoute(prop.layout + prop.path);
          initialState[prop.state || key] = isAnyChildActive;
        }
      });
    }
    return initialState;
  });

  React.useEffect(() => {
    if (routes) {
      routes.forEach((prop, key) => {
        if (prop.collapse && prop.views) {
          const isAnyChildActive =
            prop.views.some(v => activeRoute(v.layout + v.path)) ||
            activeRoute(prop.layout + prop.path);
          if (isAnyChildActive) {
            setCollapses(prev => ({
              ...prev,
              [prop.state || key]: true
            }));
          }
        }
      });
    }
  }, [pathname]);

  var links = (
    <List className={classes.list}>
      {routes.filter(p=>p.hidden==null || p.hidden == false).map((prop, key) => {
        if (prop.collapse && prop.views) {
          const collapseKey = prop.state || key;
          const isAnyChildActive =
            prop.views.some(v => activeRoute(v.layout + v.path)) ||
            activeRoute(prop.layout + prop.path);
          const isOpen = collapses[collapseKey] != null ? collapses[collapseKey] : isAnyChildActive;

          return (
            <div key={key}>
              <div
                className={classes.item}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setCollapses(prev => ({
                    ...prev,
                    [collapseKey]: !isOpen
                  }));
                }}
              >
                <ListItem
                  button
                  className={
                    classes.itemLink +
                    (isAnyChildActive ? " " + classes[color] : "")
                  }
                  style={{
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  {typeof prop.icon === "string" ? (
                    <Icon className={classes.itemIcon} style={{ float: "none", margin: 0, marginRight: 15 }}>{prop.icon}</Icon>
                  ) : (
                    <prop.icon className={classes.itemIcon} style={{ float: "none", margin: 0, marginRight: 15 }} />
                  )}
                  <ListItemText
                    primary={props.rtlActive ? prop.rtlName : prop.name}
                    className={classes.itemText}
                    disableTypography={true}
                    style={{ flex: 1, margin: 0 }}
                  />
                  {isOpen ? (
                    <ExpandLess style={{ color: "rgba(255,255,255,0.8)", fontSize: 20, flexShrink: 0 }} />
                  ) : (
                    <ExpandMore style={{ color: "rgba(255,255,255,0.8)", fontSize: 20, flexShrink: 0 }} />
                  )}
                </ListItem>
              </div>

              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingLeft: "10px" }}>
                  {prop.views.map((child, childKey) => {
                    const isChildActive = activeRoute(child.layout + child.path);
                    const ChildIcon = child.icon;
                    return (
                      <NavLink
                        to={child.layout + child.path}
                        className={classes.item}
                        activeClassName="active"
                        key={childKey}
                        style={{ margin: "2px 15px 0" }}
                      >
                        <ListItem
                          button
                          className={
                            classes.itemLink +
                            (isChildActive ? " " + classes[color] : "")
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "6px 15px",
                            paddingLeft: "20px",
                            borderRadius: "3px"
                          }}
                        >
                          {ChildIcon ? (
                            <ChildIcon
                              style={{
                                width: "18px",
                                height: "18px",
                                minWidth: "18px",
                                flexShrink: 0,
                                marginRight: "12px",
                                color: "#ffffff",
                                opacity: isChildActive ? 1 : 0.75
                              }}
                            />
                          ) : (
                            <span
                              style={{
                                width: "6px",
                                height: "6px",
                                minWidth: "6px",
                                flexShrink: 0,
                                borderRadius: "50%",
                                backgroundColor: "#ffffff",
                                marginRight: "14px",
                                opacity: isChildActive ? 1 : 0.6
                              }}
                            />
                          )}
                          <ListItemText
                            primary={child.name}
                            className={classes.itemText}
                            style={{
                              flex: 1,
                              fontSize: "12px",
                              lineHeight: "20px",
                              margin: 0
                            }}
                            disableTypography={true}
                          />
                        </ListItem>
                      </NavLink>
                    );
                  })}
                </List>
              </Collapse>
            </div>
          );
        }

        var activePro = " ";
        var listItemClasses;
        if (prop.path === "/upgrade-to-pro") {
          activePro = classes.activePro + " ";
          listItemClasses = classNames({
            [" " + classes[color]]: true
          });
        } else {
          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + prop.path)
          });
        }
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
        });
        return (
          <NavLink
            to={prop.layout + prop.path}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            <ListItem button className={classes.itemLink + listItemClasses}>
              {typeof prop.icon === "string" ? (
                <Icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive
                  })}
                >
                  {prop.icon}
                </Icon>
              ) : (
                <prop.icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive
                  })}
                />
              )}
              <ListItemText
                primary={props.rtlActive ? prop.rtlName : prop.name}
                className={classNames(classes.itemText, whiteFontClasses, {
                  [classes.itemTextRTL]: props.rtlActive
                })}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );
  let mainRoute = "/";
  if (routes && routes.length > 0 && routes[0].layout) {
    mainRoute = routes[0].layout + "/";
  } else if (window.location.pathname) {
    const segments = window.location.pathname.split("/").filter(Boolean);
    if (segments.length > 0) {
      mainRoute = "/" + segments[0] + "/";
    }
  }

  var brand = (
    <div className={classes.logo}>
      <a
        href="/"
        title="กลับหน้าหลักระบบ"
        className={classes.logoImage}
      >
        <img src={logo} alt="logo" className={classes.img} />
      </a>
      <a
        href={mainRoute}
        title={logoText}
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        style={{ display: "inline-block", verticalAlign: "middle" }}
      >
        <span style={{ fontSize: "15px" }}>
          {logoText}
        </span>
      </a>
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
